let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("44AF2")).then(() => parcelRequire('MeKSQ'));